import { AppThunkAction } from "..";
import * as services from "../service";
import {
    CSIDUserStatusActions,
    CSID_REQUEST_USER_STATUS,
    CSID_RESPONSE_USER_STATUS,
    ICSIDUserStatus,
    CSID_SSN_PINNING_STATUS,
    CSID_REFRESHING_USER_STATUS,
    SET_GLOBAL_QUESTION_TRY_COUNT,
    SET_GLOBAL_TU_OTP_TRY_COUNT,
    SET_GLOBAL_TU_OTP_REQUESTED_COUNT,
} from "./types";
import * as csidUtil from "../../components/csid/csid";

export const actionCreators = {
    getUserCSIDStatus:
        (forceFullyRefresh?: boolean): AppThunkAction<CSIDUserStatusActions> =>
        (dispatch, getState) => {
            const state = getState();

            if (state != null && state.csidUserStatusState != null && (state.csidUserStatusState.isLoading === false || forceFullyRefresh)) {
                getCSIDStatus(dispatch);
            }
        },
    componentNeedsRefresh: (): AppThunkAction<CSIDUserStatusActions> => (dispatch, getState) => {
        dispatch({ type: CSID_REFRESHING_USER_STATUS, refreshingCSIDUserStatus: true });
        setTimeout(() => {
            dispatch({ type: CSID_REFRESHING_USER_STATUS, refreshingCSIDUserStatus: false });
        }, 200);
    },
    setGlobalQuestionTryCount:
        (tryCount: number): AppThunkAction<CSIDUserStatusActions> =>
        (dispatch, getState) => {
            dispatch({ type: SET_GLOBAL_QUESTION_TRY_COUNT, globalQuestionTryCount: tryCount });
        },

    setGlobalTUOTPTryCount:
        (tryCount: number): AppThunkAction<CSIDUserStatusActions> =>
        (dispatch, getState) => {
            dispatch({ type: SET_GLOBAL_TU_OTP_TRY_COUNT, globalTUOTPTryCount: tryCount });
        },
    setGlobalTUOTPRequestedCount:
        (requestCount: number): AppThunkAction<CSIDUserStatusActions> =>
        (dispatch, getState) => {
            dispatch({ type: SET_GLOBAL_TU_OTP_REQUESTED_COUNT, globalTUOTPRequestedCount: requestCount });
        },
    updateCSIDStatus:
        (csidUserStatus: ICSIDUserStatus): AppThunkAction<CSIDUserStatusActions> =>
        (dispatch, getState) => {
            dispatch({ type: CSID_RESPONSE_USER_STATUS, csidUserStatus: csidUserStatus });

            const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus);
            if (nextStep === csidUtil.NEXT_STEP.GO_TO_DASHBOARD) {
                dispatch({ type: CSID_SSN_PINNING_STATUS, isSSNPinning: false });
            } else {
                dispatch({ type: CSID_SSN_PINNING_STATUS, isSSNPinning: true });
            }

            dispatch({ type: CSID_REQUEST_USER_STATUS, isLoading: false });
        },
};

export const getCSIDStatus = (dispatch: any) => {
    dispatch({ type: CSID_REQUEST_USER_STATUS, isLoading: true });
    services
        .getUserCSIDStatus()
        .then((data) => {
            dispatch({ type: CSID_RESPONSE_USER_STATUS, csidUserStatus: data });

            const csidUserStatus: ICSIDUserStatus = data as ICSIDUserStatus;

            const nextStep: csidUtil.NEXT_STEP = csidUtil.getNextStep(csidUserStatus);
            if (nextStep === csidUtil.NEXT_STEP.GO_TO_DASHBOARD) {
                dispatch({ type: CSID_SSN_PINNING_STATUS, isSSNPinning: false });
            } else {
                dispatch({ type: CSID_SSN_PINNING_STATUS, isSSNPinning: true });
            }

            dispatch({ type: CSID_REQUEST_USER_STATUS, isLoading: false });
        })
        .catch(function (error) {
            dispatch({ type: CSID_RESPONSE_USER_STATUS, csidUserStatus: {} as ICSIDUserStatus });
            dispatch({ type: CSID_REQUEST_USER_STATUS, isLoading: false });
        });
};
